const DESKTOP_BREAKPOINT = 768;

function moveCta() {
  document.querySelectorAll('.what-we-do').forEach(block => {
    const btn         = block.querySelector('[data-wwd-cta]');
    const mobileSlot  = block.querySelector('.what-we-do__text-area--mobile');
    const desktopSlot = block.querySelector('.sk-img-with-description__cta-wrap');

    if (!btn || !mobileSlot || !desktopSlot) return;

    if (window.innerWidth >= DESKTOP_BREAKPOINT) {
      desktopSlot.appendChild(btn);
    } else {
      mobileSlot.appendChild(btn);
    }
  });
}

window.addEventListener('load', moveCta);
window.addEventListener('resize', moveCta);
